module.exports = __webpack_public_path__ + "img/thanks_raffle.8d450b35.png";